<template>
  <div id="app" v-if="appIsReady && localesAreLoaded">
    <pwa-ios-add-to-homescreen-banner/>
    <div id="app-content" :class="['brand-'+brand, {'is-blurred': isBlurred}]">
      <transition :name="viewsTransition" :mode="viewsTransitionMode">
        <component :is="layout">
          <transition :name="viewsTransition" :mode="viewsTransitionMode">
            <template v-if="keepAlive">
              <keep-alive>
                <router-view/>
              </keep-alive>
            </template>
            <template v-else>
              <router-view/>
            </template>
          </transition>
        </component>
      </transition>
      <div id="modal-overlay"></div>
      <b-loading :is-full-page="true" :can-cancel="false" :active.sync="isLoading">
        <div class="loading-icon"></div>
        <span class="loading-message-container" v-if="loadingMessage">
                    <span class="loading-message" v-html="loadingMessage"></span>
                </span>
      </b-loading>
    </div>
    <div class="showroom-loader">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <span class="text">{{ $t("is_loading_showroom") }}</span>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import salesboxService from '@/services/salesbox/api';
import PwaIosAddToHomescreenBanner from "@/components/Pwa/PwaIosAddToHomescreenBanner.vue"
import {SALESBOX_API_URL, LOGIN_URL, MAINTENANCE} from "@/common/config";
import {SERLI_API_URL} from "@/common/config";
import {locales} from "@/common/localesList"
import router from "./router";
import {triggerTrackingEvent} from "@/common/helpers";

const default_layout = 'blank';
const currentEnv = process.env.VUE_APP_ENV;
const targetEnv = 'production';

export default {
  components: {
    PwaIosAddToHomescreenBanner,
  },
  data() {
    return {
      appIsReady: false,
      isLoading: false,
      loadingMessage: null,
      isBlurred: false,
      localesAreLoaded: false
    }
  },
  computed: {
    ...mapState({
      brand: state => state.settings.brand,
      selectLanguageFromSelectList: state => state.settings.selectLanguageFromSelectList,
      locale: state => state.settings.locale,
      lastVisit: state => state.settings.lastVisit
    }),
    layout() {
      return 'layout-' + (this.$route.meta.layout || default_layout);
    },
    keepAlive() {
      return this.$route.meta.keepAlive;
    },
    viewsTransition() {
      return this.$route.meta.viewsTransition;
    },
    viewsTransitionMode() {
      return this.$route.meta.viewsTransitionMode;
    }
  },
  created() {

    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () {
        (h.hj.q = h.hj.q || []).push(arguments)
      };
      h._hjSettings = {hjid: 2955820, hjsv: 6};
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

    document.addEventListener('swUpdated', this.showRefreshUI, {once: true});

    //this.$store.dispatch('auth/checkToken').then((returnCode) => {
    //    if(returnCode === 'redirect')
    //        this.$router.push({name:'home'})
    //    this.appIsReady = true;
    //})
    //let urlParams = new URLSearchParams(window.location.search);
    //let token = urlParams.get('token');
    //if(token) localStorage.setItem('token', token);
    //if(!localStorage.getItem('token'))
    //  window.location.href = LOGIN_URL;
    //


    if (!this.selectLanguageFromSelectList)
      this.$store.dispatch('settings/navigatorDetectLanguage', window.navigator.language)

    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleOrientation);
    this.handleResize();
    this.handleOrientation();
    this.setNavigationItems();

    this.$bus.$on('loading', (state) => {
      this.isLoading = state
      if (!state)
        this.loadingMessage = null;
    });

    this.$bus.$on('loadingMessage', (message) => this.loadingMessage = message);

    this.$bus.$on('blur', (state) => this.isBlurred = state);

    this.$bus.$on('blurMediaBox', (state) => {
      if (state) {
        setTimeout(() => {
          let overlay = document.querySelector(".wa-mediabox-overlay");
          if (overlay) {
            this.isBlurred = state;

            overlay.addEventListener("click", () => {
              this.isBlurred = false;
            });

            let closeBtn = document.querySelector(".wa-mediabox-close");
            closeBtn.addEventListener("click", () => {
              this.isBlurred = false;
            });

            let nextBtn = document.querySelector(".wa-mediabox-next");
            nextBtn.addEventListener("click", (event) => {
              let lightboxFrame = document.querySelector(".wa-mediabox-frame");
              if (lightboxFrame.classList.contains('goesToNextSlide')) {
                this.$bus.$emit('goesToNextShowroomSlider');
              } else if (!lightboxFrame.classList.contains('has-next')) {
                let nextSlideBtnShowroom = document.querySelector(".showroom-pagination .next");
                if (nextSlideBtnShowroom.classList.contains('available') && !lightboxFrame.classList.contains('has-next')) {
                  lightboxFrame.classList.add('has-next');
                  let loaderShowroom = document.querySelector(".showroom-loader");
                  loaderShowroom.classList.add('show');
                  this.$bus.$emit('loadNextShowroomSlider');
                }
              }
              event.stopPropagation();
            });
          } else {
            this.isBlurred = false;
          }
        }, 100)
      } else {
        this.isBlurred = false;
      }
    });
  },
  async mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get('token');
    if (token) localStorage.setItem('token', token);

    salesboxService.get('me').then((response) => {
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        this.$store.commit('auth/setUser', {
          email: response.data.email,
          name: response.data.name
        })
        let userDatas = response.data
        if (userDatas.cmdmids !== '') userDatas.cmdmids = JSON.parse(userDatas.cmdmids)
        if (userDatas.transacCmdmIds !== '') userDatas.transacCmdmIds = JSON.parse(userDatas.transacCmdmIds)
        if (userDatas.commercialScope !== '') userDatas.commercialScope = JSON.parse(userDatas.commercialScope)
        if (userDatas.businessTypes !== '') userDatas.businessTypes = JSON.parse(userDatas.businessTypes)
        if (userDatas.isManitouCenter !== '') userDatas.isManitouCenter = JSON.parse(userDatas.isManitouCenter)
        if (userDatas.isManitouCenterTransac !== '') userDatas.isManitouCenterTransac = JSON.parse(userDatas.isManitouCenterTransac)
        let userType = 'other'
        if ((userDatas.cmdmids && userDatas.cmdmids.length)
          && (userDatas.businessTypes && userDatas.businessTypes.includes('1DEALER'))) {
          userType = 'dealer'
        } else if ((userDatas.cmdmids && userDatas.cmdmids.length)
          && ((userDatas.isManitouCenter && userDatas.isManitouCenter.includes('Yes'))
            || (userDatas.isManitouCenterTransac && userDatas.isManitouCenterTransac.includes('Yes')))) {
          userType = 'manitou center'
        } else if ((userDatas.cmdmids && userDatas.cmdmids.length)
          && (userDatas.businessTypes && userDatas.businessTypes.includes('MAN GP COMPANY'))
          && ((!userDatas.isManitouCenter || userDatas.isManitouCenter.includes('No'))
            && (!userDatas.isManitouCenterTransac || userDatas.isManitouCenterTransac.includes('No')))) {
          userType = 'manitou group company'
        } else if (userDatas.commercialScope && userDatas.commercialScope.includes('HQ')) {
          userType = 'headquarter'
        } else if (userDatas.commercialScope
          && ((!userDatas.cmdmids || !userDatas.cmdmids.length)
            && (!userDatas.transacCmdmIds || !userDatas.transacCmdmIds.length))) {
          userType = 'subsidiary'
        }
        this.$store.commit('auth/setUserType', userType)
        console.log('Set user_type : ', userType)
        if (userType && targetEnv === currentEnv) gtag('set', 'user_properties', {
          'user_type': userType
        });

        // const dataLayer = window.dataLayer || []
        // dataLayer.push({'user_type': userType})

        // triggerTrackingEvent('user_role', userType)
        this.appIsReady = true;
        this.loadLocales();
        this.unblurOnEscapeKey();
      } else {
        this.$store.commit('auth/setUserType', 'not logged')
        console.log('Set user_type : ', 'not logged')
        if (targetEnv === currentEnv) gtag('set', 'user_properties', {
          'user_type': 'not logged'
        });
        window.location.href = LOGIN_URL;
      }
    }).catch((error) => {
      this.$store.commit('auth/setUserType', 'not logged')
      console.log('Set user_type : ', 'not logged')
      if (targetEnv === currentEnv) gtag('set', 'user_properties', {
        'user_type': 'not logged'
      });
      if(MAINTENANCE!==1) window.location.href = LOGIN_URL;
    })
  },
  methods: {

    async loadLocales() {
      //let availableLocales = locales;
      ////let availableLocales = [this.locale];
      //const locales=require("@/common/localesList")
      let availableLocales = []
      locales.forEach((locale) => {
        availableLocales.push(locale.code)
      })
      let localesPromises = []
      this.startLoading();
      availableLocales.forEach(availableLocale => localesPromises.push(salesboxService.get(`${SALESBOX_API_URL}translate/${availableLocale}`)))

      var _this = this;

      Promise.all(localesPromises).then((responses) => {
        responses.forEach(response => {

          if (!response) salesboxService.get(`${SALESBOX_API_URL}translate/`);
          let localeDatas = response.data;

          localStorage.setItem('locale_messages_' + localeDatas.locale, JSON.stringify(localeDatas.messages))
          this.$i18n.setLocaleMessage(localeDatas.locale, localeDatas.messages)
        })
      }).catch(
          function (error) {
            console.log('Génération des fichiers')
            if (Promise.reject(error)) {
              console.log(localStorage.getItem('token'))
              //salesboxService.get(`${SALESBOX_API_URL}translate`).finally(() => {_this.loadLocales()});
            }
          }
      ).finally(() => {
        this.$i18n.locale = this.locale;

        this.$store.commit('settings/setLocale', this.locale);
        this.$store.commit('vuetour/reset');
        this.$store.dispatch('settings/loadCommonDatas');
        this.setNavigationItems();
        this.localesAreLoaded = true;
        this.stopLoading();
      });


    },
    showRefreshUI() {
      this.$snackbar.open({
        message: this.$t('a_new_version_of_the_application_is_available'),
        type: 'is-warning',
        position: 'is-top',
        actionText: this.$t('refresh_page'),
        indefinite: true,
        onAction: () => window.location.reload(true)
      })
    },
    unblurOnEscapeKey() {
      document.body.addEventListener("keydown", (e) => {
        var isEscape = false;

        if ("key" in e)
          isEscape = (e.key === "Escape" || e.key === "Esc");
        else
          isEscape = (e.keyCode === 27);

                    if(isEscape)
                        this.isBlurred = false;
                });
            },
            handleResize() {
                this.$store.dispatch('settings/deviceDetection', window.innerWidth)
            },
            handleOrientation() {
              this.$store.dispatch('settings/deviceOrientation', window.orientation)
            },
            setNavigationItems() {
                /*if(this.getEnv === 'test') {
                    this.$store.commit('settings/setNavigationItems', [
                        {
                            type: 'home',
                            icon: 'icon-target',
                            title: this.$t('i_qualify'),
                            subtitle: this.$t('find_the_best_solutions'),
                            linkText: this.$t('learn_more'),
                            route: { path: "/home" }
                        },
                        {
                            type: 'search',
                            icon: 'icon-search',
                            title: this.$t('i_search'),
                            subtitle: this.$t('i_search_brand_product', {brand: 'MANITOU'}),
                            linkText: this.$t('learn_more'),
                            route: { path: "/search" }
                        },
                        {
                            type: 'compare',
                            icon: 'icon-compare',
                            title: this.$t('i_compare'),
                            subtitle: this.$t('compare_competitors_machines_to_brand_machines', {brand: 'MANITOU'}),
                            linkText: this.$t('learn_more'),
                            route: { name: "compare-selection" }
                        },
                        {
                            type: 'formation',
                            icon: 'icon-formation',
                            title: this.$t('i_train_myself'),
                            subtitle: 'COMING SOON',
                            linkText: this.$t('learn_more'),
                            route: { name: 'coming-soon-formation'},
                            comingSoon: true
                        },
                    ]);
                }else {*/
              let routeQualify={ name: 'coming-soon-qualify'}
              if(this.getEnv!=='production')
                // routeQualify={ path: '/qualify-industry/building-and-shelving?init=1'}
                routeQualify={ path: '/qualify'}
                    this.$store.commit('settings/setNavigationItems', [
                        {
                            type: 'qualify',
                            icon: 'icon-target',
                            title: this.$t('i_qualify'),
                            subtitle: 'COMING SOON',
                            linkText: this.$t('learn_more'),
                            route: routeQualify,
                            comingSoon: true
                        },
                        {
                            type: 'search',
                            icon: 'icon-search',
                            title: this.$t('i_search'),
                            subtitle: this.$t('i_search_brand_product', {brand: 'MANITOU'}),
                            linkText: this.$t('learn_more'),
                            route: { path: "/search" },
                            hideOnHomepage: true
                        },
                        //{
                        //    type: 'formation',
                        //    icon: 'icon-formation',
                        //    title: this.$t('i_train_myself'),
                        //    subtitle: 'COMING SOON',
                        //    linkText: this.$t('learn_more'),
                        //    route: { name: 'coming-soon-formation'},
                        //    comingSoon: true
                        //},
                        {
                            type: 'compare',
                            icon: 'icon-compare',
                            title: this.$t('i_compare'),
                            subtitle: this.$t('compare_competitors_machines_to_brand_machines', {brand: 'MANITOU'}),
                            linkText: this.$t('learn_more'),
                            route: { name: "compare-selection" }
                        },
                    ]);
                //}
            },
        }
    }
</script>

<style lang="scss" src="./assets/scss/_loader.scss"></style>
<style lang="scss">
@import './assets/scss/libraries/loader';

#app {
  #app-content {
    &.is-blurred {
      filter: blur(20px);
      height: 100vh;
      overflow: hidden;
    }

    #modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      background-color: $black;
      opacity: 0;
    }

    .loading-overlay {
      .loading-message-container {
        position: absolute;
        top: calc(50% + 60px);
        left: 0;
        right: 0;
        text-align: center;

        .loading-message {
          display: inline-block;
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 5px;
          padding: 10px;
          font-size: 18px;
          line-height: 20px;
          font-weight: 700;
          color: $greyish-brown;

          span {
            display: block;
            margin-top: 10px;
            font-weight: 400;
          }
        }
      }
    }
  }

  .showroom-loader {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    position: fixed;
    opacity: 0;
    visibility: hidden;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    transition: all $duration $easeInOutCirc;
    z-index: 999999;

    &.show {
      visibility: visible;
      transition: all $duration $easeInOutCirc;
      opacity: 1.0;
    }

    .text {
      display: block;
      color: #fff;
      font-weight: 300;
      letter-spacing: 0.01rem;
      font-size: 13px;
      margin-top: 20px;
    }
  }
}
</style>
